import React from 'react';

import { PageHeader, Tooltip, Button } from 'antd';
import Swal from 'sweetalert2';
import { MyBreadcrumb } from 'utils';
import ExpectScripts from 'utils/ExpectScripts';

import { CaretRightOutlined } from '@ant-design/icons';
export default function Index() {
  const manualExpansiveWorkspaceCon = async (url) => {
    const { value: referenceId } = await Swal.fire({
      title: '',
      input: 'text',
      inputLabel: 'Your branch network reference ID',
      inputPlaceholder: 'Reference ID',
    });
    if (referenceId) {
      window.open(url + '&referenceId=' + referenceId, '_blank');
    }
  };

  const columns = [
    {
      title: 'No.',
      dataIndex: 'key',
      key: 'key',
      render: (text, record, index) => <>{index + 1}</>,
    },
    {
      title: 'Scripts',
      dataIndex: 'title',
      key: 'title',
      render: (text, record) => <>{record.title}</>,
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Tooltip title="Action">
          {record.askReferenceId ? (
            <Button
              onClick={() => manualExpansiveWorkspaceCon(record.url)}
              type="secondary"
              shape="circle"
              icon={<CaretRightOutlined />}
            />
          ) : (
            <Button
              onClick={() => window.open(record.url, '_blank')}
              type="primary"
              shape="circle"
              icon={<CaretRightOutlined />}
            />
          )}
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <MyBreadcrumb
        items={[
          { label: 'Home', path: '/' },
          { label: 'Manage Device Scripts', path: '' },
        ]}
      />
      <PageHeader
        ghost={false}
        title={`Manage Device Scripts`}
        subTitle="Select which scripts need to be available for execution"
        style={{ height: '100vh' }}
      >
        <ExpectScripts settingKey="EXPECT_SCRIPTS_ADMIN" />
      </PageHeader>
    </>
  );
}
